/**
 * Retrieves the QA team data.
 * @returns {Array<Object>} The QA team array containing team member details.
 */
export function getQATeam() {
    return qateam;
}

/**
 * Array of QA team members with their details.
 * @type {Array<Object>}
 * @property {number} id - Unique identifier for each team member.
 * @property {string} name - Name of the team member.
 * @property {string} icon - Icon associated with the team member.
 * @property {string} value - Value related to the team member's performance.
 */
const qateam = [
    { id: 1, name: 'TOTAL VENTAS', icon: 'icon-money', value: '5.875' },
    { id: 2, name: 'TOTAL PREMIOS', icon: 'icon-money', value: '77.829' },
    { id: 3, name: 'TOTAL GANANCIA', icon: 'icon-financial', value: '2.342' },
];

// FILE DOCUMENTED
